import Image from 'next/image'
import Link from 'next/link'

const ListBots = () => {
  return (
    <div className="custom-scrollbar h-full space-y-4 overflow-y-auto">
      {Array.from({ length: 20 }).map((_, i) => (
        <Link
          href={`/bot-store/${i + 1}`}
          key={i}
          className="bg-tb-grayscale-800/50 hover:bg-tb-grayscale-950 block p-4 transition-all duration-300"
        >
          <div className="flex items-center gap-x-1">
            <div>
              <Image src="/images/bot-icon.png" width={60} height={60} alt="Bot" />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Bot Name</h2>
              <p className="uppercase">*****</p>
            </div>
          </div>

          <div className="items-end justify-between space-y-4 md:flex md:space-y-0">
            <div className="space-y-2">
              <p>+71.93%</p>
              <p>
                Won last <span className="text-tb-success-500">30</span> days
              </p>
              <p>
                Total profit <span className="text-tb-success-500">$12,22.83</span>
              </p>
              <p>
                <span className="text-tb-success-500">44</span> Deployments (
                <span className="text-tb-success-500">^ 4</span> last 7D)
              </p>
            </div>

            <div className="space-y-2">
              <div className="border-tb-success-500 h-28 w-60 border"></div>
              <p className="text-tb-success-500 font-medium md:text-right">0.00 USD/month</p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default ListBots
